import DrawRoutes from './components/DrawRoutes';
import ApplicationsRoutes from './components/ApplicationsRoutes';
import LoanRoutes from './components/Loans/LoanRoutes';
import WatchlistRoutes from './components/WatchlistRoutes';
import InsurancesRoutes from './components/InsuranceRoutes';
import NoticesRoutes from './components/NoticesRoutes';
import PaymentsRoutes from './components/PaymentsRoutes';
import ValuationsRoutes from './components/ValuationsRoutes';
import BorrowersRoutes from './components/BorrowersRoutes';
import HMDARoutes from './components/HMDARoutes';
import UsersRoutes from './components/UsersRoutes';
import TemplatesRoutes from './components/TemplatesRoutes';
import ExperienceRoutes from './components/ExperienceRoutes';
import TranscriptReviewRoutes from './components/TranscriptReviewRoutes';
import FeedbackRoutes from './components/FeedbackRoutes';
import EstimatorRoutes from './components/EstimatorRoutes';
import ReferralsRoutes from './components/ReferralsRoutes';
import DemographicsRoutes from './components/DemographicsRoutes';
import UserAgreementRoutes from './components/UserAgreementRoutes';
import { Route } from 'react-router-dom';
import { OldAdminScss, oldAdminLoader } from '../components/OldAdminScss';
import LendingLimitRoutes from './components/LendingLimitRoutes';
import BridgeRoutes from './components/BridgeRoutes';

export default function AdminRoutes() {
    return (
        <Route
            element={<OldAdminScss />}
            loader={oldAdminLoader}
        >
            {UserAgreementRoutes()}
            {ReferralsRoutes()}
            {DemographicsRoutes()}
            {ApplicationsRoutes()}
            {TranscriptReviewRoutes()}
            {DrawRoutes()}
            {LoanRoutes()}
            {WatchlistRoutes()}
            {ValuationsRoutes()}
            {InsurancesRoutes()}
            {NoticesRoutes()}
            {PaymentsRoutes()}
            {BorrowersRoutes()}
            {HMDARoutes()}
            {UsersRoutes()}
            {TemplatesRoutes()}
            {ExperienceRoutes()}
            {FeedbackRoutes()}
            {EstimatorRoutes()}
            {LendingLimitRoutes()}
            {BridgeRoutes()}
        </Route>
    );
}
